import { render, staticRenderFns } from "./OrderRefund.vue?vue&type=template&id=3b5173a5&scoped=true"
import script from "./OrderRefund.vue?vue&type=script&lang=js"
export * from "./OrderRefund.vue?vue&type=script&lang=js"
import style0 from "./OrderRefund.vue?vue&type=style&index=0&id=3b5173a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5173a5",
  null
  
)

export default component.exports